// extracted by mini-css-extract-plugin
export var attachment = "_mj-a";
export var emailContainer = "_mj-4";
export var emailContentPaddedContainer = "_mj-b";
export var emailHeader = "_mj-6";
export var emailIframe = "_mj-3";
export var emailInfoIcon = "_mj-9";
export var emailShortenedSummary = "_mj-e";
export var infoDropdown = "_mj-0";
export var infoRowBoundedContent = "_mj-d";
export var internal = "_mj-5";
export var merchant = "_mj-8";
export var messageInputContainer = "_mj-h";
export var normal = "_mj-7";
export var replyCard = "_mj-f";
export var subtleButton = "_mj-1";
export var subtleButtonIconContainer = "_mj-2";
export var toggleViewRepliesButton = "_mj-c";
export var wrappingText = "_mj-g";